export const getOrganizationTypeName = ({ isMentoringCustomer }: { isMentoringCustomer: boolean }) =>
  isMentoringCustomer ? 'Mentoring Works' : 'Civic Champs'
